// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 600px) {
    .input {
        height: 40px;
        width: 80%;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        padding: 0 10px;
        font-size: 16px;
        outline: none;
        transition: 0.3s;
    }
}

@media only screen and (min-width: 600px) {
    .input {
        height: 40px;
        width: 50%;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        padding: 0 10px;
        font-size: 16px;
        outline: none;
        transition: 0.3s;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/inputs/Input.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;QACZ,UAAU;QACV,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,eAAe;QACf,aAAa;QACb,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,UAAU;QACV,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,eAAe;QACf,aAAa;QACb,gBAAgB;IACpB;AACJ","sourcesContent":["@media only screen and (max-width: 600px) {\n    .input {\n        height: 40px;\n        width: 80%;\n        border: 1px solid #e0e0e0;\n        border-radius: 5px;\n        padding: 0 10px;\n        font-size: 16px;\n        outline: none;\n        transition: 0.3s;\n    }\n}\n\n@media only screen and (min-width: 600px) {\n    .input {\n        height: 40px;\n        width: 50%;\n        border: 1px solid #e0e0e0;\n        border-radius: 5px;\n        padding: 0 10px;\n        font-size: 16px;\n        outline: none;\n        transition: 0.3s;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
